import React from "react";
import { DragDropContext } from "react-beautiful-dnd";

import KanbanContainor from "../../../../components/Kanban/KanbanContainer";
import OpenCardDetail from "./openCardDetail";
import { useKanbanBoardDrag } from "./hooks/useKanbanBoardDrag";

function KanbanBoard({ workflowSteps, cards, id, boardName, sameWorkFlowIdcards = [] }) {
  const { localCards, onDragEnd } = useKanbanBoardDrag({ cards, id });

  return (
    <>
      <OpenCardDetail cardsOnBoard={sameWorkFlowIdcards} />
      <DragDropContext onDragEnd={onDragEnd}>
        <KanbanContainor
          key={`${id}-board`}
          boardName={boardName}
          projects={localCards}
          workflowSteps={workflowSteps}
          boardId={id}
        />
      </DragDropContext>
    </>
  );
}

export default React.memo(KanbanBoard);
